/* Delegation also supports sections re-rendered in the Shopify editor. */
document.addEventListener('input', (event) => {
  const input = event.target;
  if (!input.matches('[data-lamp-comparison] input')) return;
  input.closest('[data-lamp-comparison]').style.setProperty('--reveal', `${input.value}%`);
  input.setAttribute('aria-valuetext', `${input.value}% before image revealed`);
});
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-lamp-buy]');
  if (!link) return;
  const product = document.querySelector('product-information');
  const target = product?.querySelector('h1') || document.querySelector('main h1');
  if (!target) return;
  event.preventDefault();
  target.setAttribute('tabindex', '-1');
  target.focus({ preventScroll: false });
});

// Enhance the two story films only after the player events are ready. Without JS,
// the original native video controls remain usable.
function setupLampVideos(root = document) {
  root.querySelectorAll('.mv-lamp__video-frame:not(.is-enhanced)').forEach((frame) => {
    const video = frame.querySelector('video');
    const seek = frame.querySelector('[data-lamp-video-seek]');
    const playButtons = frame.querySelectorAll('[data-lamp-video-play], [data-lamp-video-toggle]');
    const sound = frame.querySelector('[data-lamp-video-mute]');
    const fullscreen = frame.querySelector('[data-lamp-video-fullscreen]');
    if (!video || !seek || !playButtons.length || !sound || !fullscreen) return;

    const sync = () => {
      frame.classList.toggle('is-playing', !video.paused && !video.ended);
      frame.classList.toggle('is-muted', video.muted);
      playButtons.forEach((button) => button.setAttribute('aria-label', video.paused ? 'Play video' : 'Pause video'));
      sound.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      const progress = Number.isFinite(video.duration) && video.duration > 0 ? video.currentTime / video.duration * 100 : 0;
      seek.value = String(progress);
      seek.style.setProperty('--mv-video-progress', `${progress}%`);
      seek.setAttribute('aria-valuetext', Number.isFinite(video.duration) ? `${Math.floor(video.currentTime)} of ${Math.floor(video.duration)} seconds` : 'Video not loaded');
    };
    const toggle = () => {
      if (video.paused) video.play().catch(() => { video.setAttribute('controls', ''); frame.classList.remove('is-enhanced'); });
      else video.pause();
    };
    playButtons.forEach((button) => button.addEventListener('click', toggle));
    video.addEventListener('click', toggle);
    sound.addEventListener('click', () => { video.muted = !video.muted; sync(); });
    seek.addEventListener('input', () => {
      if (Number.isFinite(video.duration) && video.duration > 0) video.currentTime = Number(seek.value) / 100 * video.duration;
      sync();
    });
    fullscreen.addEventListener('click', () => {
      if (document.fullscreenElement === frame) document.exitFullscreen();
      else if (frame.requestFullscreen) frame.requestFullscreen().catch(() => {});
      else if (video.webkitEnterFullscreen) video.webkitEnterFullscreen();
    });
    video.addEventListener('error', () => { video.setAttribute('controls', ''); frame.classList.remove('is-enhanced'); });
    ['play', 'pause', 'timeupdate', 'loadedmetadata', 'volumechange', 'ended'].forEach((name) => video.addEventListener(name, sync));
    video.removeAttribute('controls');
    frame.classList.add('is-enhanced');
    sync();
  });
}
setupLampVideos();
document.addEventListener('shopify:section:load', (event) => setupLampVideos(event.target));
